import { useEffect } from "react";

import OneTrust from "shared/util/oneTrust";

const GOOGLE_REMARKETING_SDK_URL = "https://www.googleadservices.com/pagead/conversion.js";

const initGoogleRemarketing = () => {
	window.google_conversion_id = 829392633;
	window.google_custom_params = window.google_tag_params;
	window.google_remarketing_only = true;
};

function useGoogleRemarketing() {
	useEffect(() => {
		initGoogleRemarketing();
		OneTrust.loadJS(GOOGLE_REMARKETING_SDK_URL, OneTrust.CATEGORY.ADVERTISING);
	}, []);
}

export default useGoogleRemarketing;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useGoogleRemarketing.js